<template>
  <entity-list v-if="$route.params.id === undefined"
               :form-config="formConfig"
  />

  <tab-edit v-else-if="$route.params.id !== undefined"
            :entity-id="$route.params.id"
            :tab-config="tabConfig"
  />


</template>
<script>
import {
  FormConfig,
  PropertyConfig,
  FieldType,
  Filter,
  Operator,
  FunctionButton,
  Action,
  TabConfig,
  Tab
} from '../../common/index.d.ts'
import EntityList from '../../common/EntityList'
import EntityEdit from '../../common/EntityEdit'
import TabEdit from '../../common/TabEdit'

import {ref} from '@vue/composition-api'
import {useRouter} from '@core/utils/utils'
import store from '@/store'

export default {
  components: {
    TabEdit,
    EntityList,
    EntityEdit,
  },

  setup(props) {
    const router = useRouter().route;
    let entityId = undefined
    try {
      entityId = router.value.params.id
    } catch (e) {

    }
    let arr = [
      new PropertyConfig("id", "Id", FieldType.TEXT),
      new PropertyConfig("name", "Name", FieldType.TEXT),
      new PropertyConfig("partial", "Partial", FieldType.SWITCH),
      new PropertyConfig("language", "Language", FieldType.SELECT_ARRAY).withRef(ref(["en", "cn"])),
      new PropertyConfig("inline_edit", "Inline enabled", FieldType.SWITCH),
      new PropertyConfig("template_full", "Full Template", FieldType.SWITCH),
      new PropertyConfig("search", "Search", FieldType.SWITCH),
    ];
    let formConfig = new FormConfig(undefined, arr, "template").withSearchName("name").withActions(
        [new Action("Edit", "apps-template"),
          new Action("Inline", "template-inline")]);
    formConfig.withFilters(
        [
          // new Filter("name", "Name", FieldType.TEXT, Operator.CN),
          // new Filter("language", "Language", FieldType.SELECT_ARRAY, Operator.CN).withRef(ref(["en", "cn"]))
        ])


    formConfig.withFunctionButtons([new FunctionButton("Scan", "template/scan", "Scan template successfully"),
      new FunctionButton("Sync", "template/synchronize", "Synchronize template successfully")
    ])

    let pc = new PropertyConfig("content", "Content", FieldType.FREEMARKER).withHideInList(true)
    pc.md = 12
    let a2 = [
      pc,
    ]

    let tab = new Tab("Generic", formConfig)
    let meta = new Tab("Content", new FormConfig(undefined, a2, "template"))
    let configs = [tab, meta];
    let tabConfig = new TabConfig(
        configs,
        "template"
    );
    return {
      entityId,
      formConfig,
      tabConfig,
    }
  },
}
</script>

